module.exports = __webpack_public_path__ + "img/bluesky15.d10dbe93.jpg";